// Local storage (persisted)
export const BUILD_TIMESTAMP = 'build-timestamp';

// Local storage (clearable)
export const PREFERS_DARK_MODE = 'prefers-dark-mode';
export const AUTH_SIGN_OUT = 'check-sign-out';
export const AUTH_SIGN_IN = 'check-sign-in';
export const SIGN_IN_EMAIL = 'sign-in-email';
export const SHOULD_STORE_EMAIL = 'should-store-email';

// Session storage
export const ERROR_TRACE = 'error-trace';

// Guided mode
export const GUIDED_MODE = 'guided-mode-enabled';
